import { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { analyticsSearch, changeAnalyticsFilter, EMPTY_ANALYTICS_FILTERS, readAnalyticsFilters } from "./analyticsFilters";

export default function useAnalyticsFilters(plantId) {
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.toString();
  const appliedFilters = useMemo(() => readAnalyticsFilters(search), [search]);
  const [draftFilters, setDraftFilters] = useState(appliedFilters);
  const previousPlant = useRef(plantId);

  useEffect(() => { setDraftFilters(appliedFilters); }, [appliedFilters]);
  useEffect(() => {
    if (previousPlant.current !== plantId) {
      previousPlant.current = plantId;
      setDraftFilters(EMPTY_ANALYTICS_FILTERS);
      setSearchParams({}, { replace: true });
    }
  }, [plantId, setSearchParams]);

  return {
    appliedFilters,
    draftFilters,
    changeFilter: (key, value) => setDraftFilters((current) => changeAnalyticsFilter(current, key, value)),
    applyFilters: () => setSearchParams(analyticsSearch(draftFilters)),
    resetFilters: () => { setDraftFilters(EMPTY_ANALYTICS_FILTERS); setSearchParams({}); },
  };
}
